export const PARENT_CONTACT_ANALYTICS_SOURCES = {
  SETTINGS: 'settings',
  HOME_BANNER: 'home_banner',
  POST_PAYMENT: 'post_payment'
} as const;

export type ParentContactAnalyticsSource =
  typeof PARENT_CONTACT_ANALYTICS_SOURCES[keyof typeof PARENT_CONTACT_ANALYTICS_SOURCES];
